








































































import Vue from 'vue'

export default Vue.extend({
  props: {
    total: {
      type: Number,
      required: true
    },
    active: {
      type: Number,
      required: true
    }
  },
  methods: {
    /**
     * Remove focus since the link value will be
     * updated after the click event.
     *
     * @param {ClickEvent} e
     */
    blur: ({ target }: { target: HTMLElement }) => {
      target.blur()
    }
  }
})
